// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__E-g2s","item":"PaymentsMobile_item__3YDKO","label":"PaymentsMobile_label__977od","amount":"PaymentsMobile_amount__1XswV"};